import { useSuspenseQuery } from '@tanstack/react-query'

import {
  GetPropostaDuplicarService,
  type TGetPropostaDuplicarResponse,
} from '@/features/proposta/services/get-proposta-duplicar.service'
import { propostaKeys } from '@/features/proposta/utils'

export const useSuspensePropostaDuplicar = (numero: number) => {
  return useSuspenseQuery<TGetPropostaDuplicarResponse>({
    queryKey: propostaKeys.duplicar(numero),
    queryFn: () => new GetPropostaDuplicarService().execute(numero).then((response) => response.data),
  })
}
